// Camera Filters Configuration
// These filters use CSS filter properties for real-time video/image processing

export const CAMERA_FILTERS = [
  {
    id: 'none',
    name: 'Normal',
    icon: '🔲',
    filter: 'none',
    overlay: null
  },
  {
    id: 'vivid',
    name: 'Vivid',
    icon: '🌈',
    filter: 'saturate(1.4) contrast(1.1)',
    overlay: null
  },
  {
    id: 'warm',
    name: 'Warm',
    icon: '🌅',
    filter: 'sepia(0.3) saturate(1.2) brightness(1.05)',
    overlay: null
  },
  {
    id: 'cool',
    name: 'Cool',
    icon: '❄️',
    filter: 'saturate(0.9) hue-rotate(20deg) brightness(1.05)',
    overlay: null
  },
  {
    id: 'vintage',
    name: 'Vintage',
    icon: '📷',
    filter: 'sepia(0.4) contrast(1.1) brightness(0.95)',
    overlay: 'rgba(255, 200, 150, 0.1)'
  },
  {
    id: 'bw',
    name: 'B&W',
    icon: '⬛',
    filter: 'grayscale(1) contrast(1.2)',
    overlay: null
  },
  {
    id: 'dramatic',
    name: 'Dramatic',
    icon: '🎭',
    filter: 'contrast(1.3) saturate(1.2) brightness(0.9)',
    overlay: null
  },
  {
    id: 'soft',
    name: 'Soft',
    icon: '☁️',
    filter: 'brightness(1.1) contrast(0.95) saturate(0.9)',
    overlay: 'rgba(255, 255, 255, 0.05)'
  },
  {
    id: 'neon',
    name: 'Neon',
    icon: '💜',
    filter: 'saturate(1.5) contrast(1.2) hue-rotate(-10deg)',
    overlay: 'rgba(255, 0, 255, 0.05)'
  },
  {
    id: 'sunset',
    name: 'Sunset',
    icon: '🌇',
    filter: 'sepia(0.2) saturate(1.3) hue-rotate(-15deg) brightness(1.05)',
    overlay: 'rgba(255, 100, 50, 0.08)'
  },
  {
    id: 'ocean',
    name: 'Ocean',
    icon: '🌊',
    filter: 'saturate(1.1) hue-rotate(30deg) brightness(1.05)',
    overlay: 'rgba(0, 150, 255, 0.05)'
  },
  {
    id: 'forest',
    name: 'Forest',
    icon: '🌲',
    filter: 'saturate(1.2) hue-rotate(50deg) brightness(0.95)',
    overlay: 'rgba(0, 100, 0, 0.05)'
  },
  {
    id: 'pink',
    name: 'Pink',
    icon: '💗',
    filter: 'saturate(1.2) hue-rotate(-30deg) brightness(1.05)',
    overlay: 'rgba(255, 150, 200, 0.1)'
  },
  {
    id: 'golden',
    name: 'Golden',
    icon: '✨',
    filter: 'sepia(0.25) saturate(1.3) brightness(1.1)',
    overlay: 'rgba(255, 215, 0, 0.08)'
  },
  {
    id: 'noir',
    name: 'Noir',
    icon: '🖤',
    filter: 'grayscale(1) contrast(1.4) brightness(0.85)',
    overlay: null
  },
  {
    id: 'retro',
    name: 'Retro',
    icon: '📼',
    filter: 'sepia(0.5) saturate(1.1) contrast(1.1) brightness(0.95)',
    overlay: 'rgba(200, 150, 100, 0.1)'
  }
];

// Apply filter to canvas for image/video capture
export const applyFilterToCanvas = (canvas, filterId) => {
  const filter = CAMERA_FILTERS.find(f => f.id === filterId);
  if (!filter || filter.id === 'none') return;
  
  const ctx = canvas.getContext('2d');
  ctx.filter = filter.filter;
  
  // If there's an overlay, apply it
  if (filter.overlay) {
    ctx.fillStyle = filter.overlay;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }
};

// Get CSS filter string for video element
export const getFilterStyle = (filterId) => {
  const filter = CAMERA_FILTERS.find(f => f.id === filterId);
  return filter?.filter || 'none';
};

// Get overlay color for filter
export const getFilterOverlay = (filterId) => {
  const filter = CAMERA_FILTERS.find(f => f.id === filterId);
  return filter?.overlay || null;
};

export default CAMERA_FILTERS;
